export default class DoctoralListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, Requests, $sessionStorage) {
    var doctoralListVm = this

    // VARIABLES
    doctoralListVm.mainLabel = 'Formación doctoral'
    doctoralListVm.viewLoaded = false
    doctoralListVm.dataList = []
    doctoralListVm.active = GlobalConfig.generals.active
    doctoralListVm.notActive = GlobalConfig.generals.notActive
    doctoralListVm.inReview = 0
    doctoralListVm.feedback = 0
    doctoralListVm.planningFinish = true
    doctoralListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    doctoralListVm.$sessionStorage = $sessionStorage

    const currentUser = JSON.parse($cookies.get('currentUser'))

    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

    doctoralListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    $scope.breakpoints = [
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

    // METHODS
    doctoralListVm.backgroundGrad = backgroundGrad
    doctoralListVm.updateView = updateView
    doctoralListVm.loadData = loadData
    doctoralListVm.confirmDeleteDoctorate = confirmDeleteDoctorate
    doctoralListVm.getGeneralsWorkplan = getGeneralsWorkplan
    doctoralListVm.bitacora = bitacora

    activate()

    function activate () {
      if(doctoralListVm.workPlanGeneralList != undefined){
        doctoralListVm.status = doctoralListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        doctoralListVm.stages = doctoralListVm.workPlanGeneralList.stages
        doctoralListVm.inReview = doctoralListVm.status.reviewed
        doctoralListVm.feedback = doctoralListVm.status.feedbackReviewed
        doctoralListVm.workplanTeacherId = doctoralListVm.status.workplanTeacherId
        isPlanning(doctoralListVm.status, doctoralListVm.stages)

        if (doctoralListVm.feedback && !doctoralListVm.planningFinish) {
          getDataPhdListReject()
        }else{ 
          getDataPhdList() 
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if (doctoralListVm.feedback && !doctoralListVm.planningFinish) {
            getDataPhdListReject()
          }else{ 
            getDataPhdList() 
          }
        })
      }

      updateView()
    }

    function getDataPhdList () {
      WorkPlanSrv.getDataPhdList.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listphd)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(listphd)
        }
      )
    }

    function getDataPhdListReject () {
      WorkPlanSrv.getDataPhdListReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listphd)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(listphd)
        }
      )
    }

    function loadData (data) {
      doctoralListVm.dataList = data
      updateView()
    }

    function updateView () {
      doctoralListVm.viewLoaded = false
      $timeout(() => {
        doctoralListVm.viewLoaded = true
      }, 1)
    }

    function backgroundGrad (index) {
      let result = 'grad-oblique-'

      switch (index % 4) {
        case 0:
          return result + 'negro-dark'
        case 1:
          return result + 'azul'
        case 2:
          return result + 'teal'
        case 3:
          return result + 'deep-orange'
        default:
          return result + 'negro-dark'
      }
    }

    function confirmDeleteDoctorate (doc) {
      let docName = doc.nameStudy
      let workplanTeacherActivityId = doc.workplanTeacherActivityId
      // console.log(doc)
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.docName = docName
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteDoctorate = function () {
            WorkPlanSrv.disableActivityTeachingStaff.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeDoctorateFromCaroussel(doc)
                showDeletedDoctorateSuccessfully(ctrlModalVM.docName)
                WorkPlanIndicatorSrv.setVariable(true)
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteDoctorateModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedDoctorateSuccessfully (doctorateName) {
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit: texts.deleteDialog,
        textCreateOrEdit: texts.deleted,
        itemName: doctorateName,
        nameModal: texts.modalTypeName.deleted,
        modalType: texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function removeDoctorateFromCaroussel (doc) {
      for (var i in doctoralListVm.dataList) {
        if (doctoralListVm.dataList[i].workplanTeacherActivityId === doc.workplanTeacherActivityId) {
          doctoralListVm.dataList.splice(i, 1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan (post) {
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          doctoralListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          doctoralListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          doctoralListVm.stages = dataReturn.data.stages
          doctoralListVm.inReview = doctoralListVm.status.reviewed
          doctoralListVm.feedback = doctoralListVm.status.feedbackReviewed
          doctoralListVm.workplanTeacherId = doctoralListVm.status.workplanTeacherId
          isPlanning(doctoralListVm.status, doctoralListVm.stages)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function isPlanning (status, stages) {
      doctoralListVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
      for (var i = stages.length - 1; i >= 0; i--) {
        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
          doctoralListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == doctoralListVm.active) {
          doctoralListVm.planningFinish = true
          if (doctoralListVm.startDateReview < doctoralListVm.currentDate || status.reviewedFinish == doctoralListVm.active) {
            doctoralListVm.planningFinish = true
          } else if (status.reviewedReject == doctoralListVm.active) {
            doctoralListVm.planningFinish = false
          }
        } else {
          doctoralListVm.planningFinish = false
        }
      }else{
        doctoralListVm.planningFinish = true
      }

      $scope.classPlanning = (doctoralListVm.planningFinish ? 'disabled' : ' ')
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.doctoralEducation,
        workplanTeacherId: doctoralListVm.workplanTeacherId
      }
      entries.title = 'Formación Doctoral'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
  }
}

DoctoralListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'Requests','$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/doctoralFormation/list/doctoralListCtrl.js